import React, { useEffect } from "react";
import Title from "antd/es/typography/Title";
import { fancyUlTextRenderer } from "../../Utils/utils";
import stylishUnderline from "../../Assets/Icons/underline-2.svg";
import "./index.scss";
import { navItemHighlighter } from "../../Utils/helper";
import { useLocation } from "react-router-dom";
import BeehiivForm from "../../Components/BeehiivForm";

const NewsLetter = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    navItemHighlighter(true, pathname);
  }, [pathname]);

  return (
    <div className="newsletter-container">
      <Title
        level={1}
        style={{ marginTop: "0px", marginBottom: "0" }}
        className="banner_heading"
      >
        Your Gateway to
      </Title>
      <Title
        level={1}
        style={{ marginTop: "0px", marginBottom: "0.5em !important" }}
        className="banner_heading"
      >
        Exclusive{" "}
        {fancyUlTextRenderer(stylishUnderline, "Breakout", "#5D5BF6")}{" "}
        Opportunities
      </Title>
      <Title level={4} className="banner_text" style={{ marginTop: "0px" }}>
        Subscribe to our newsletter for confidential roles tailored just for
        you.
      </Title>
      <div className="newsletter-box">
        <BeehiivForm className="newsletter-form-container" />
      </div>
    </div>
  );
};

export default NewsLetter;
